import { apiProxyRequest } from "Api/apiProxyRequest";
import { resolveIfHasLink } from "Api/utils";
import { resolveRefLinks } from "Api/ref/resolveRefLinks";

import type { InvoiceDetailsResponse } from "../types";
import type { RefOrganization } from "Api/ref/Organization.types";
import type { RefProject } from "Api/ref/Project.types";

export const getInvoiceDetailsRequest = (
  billingProfileId: string,
  invoiceId: string
) => {
  return apiProxyRequest<InvoiceDetailsResponse>(
    `/billing/profiles/${billingProfileId}/invoices/${invoiceId}/details`
  );
};

// Resolves the `ref:organizations:N` / `ref:projects:N` links the invoice
// details endpoint exposes so the page can show organization and project names
// instead of their IDs. Each resolver is only defined when the matching link is
// present, mirroring how billing users resolve `ref:users:0`.
export const resolveInvoiceDetailsLinks = (
  details: InvoiceDetailsResponse
) => ({
  organizations: resolveIfHasLink(details, "ref:organizations:0", () =>
    resolveRefLinks<RefOrganization>(details, "ref:organizations:")
  ),
  projects: resolveIfHasLink(details, "ref:projects:0", () =>
    resolveRefLinks<RefProject>(details, "ref:projects:")
  )
});
